import { extend } from 'quasar'
import * as shvl from 'shvl'

import { deleteActionColumn, editActionColumn } from '../_defaults/columns'

export const defaultSettings = {
  groupedByField: 'id',
  parentResource: null,
  visibleColumns: [],
  selected: [],
  layout: 'table',
  azOpen: false,
  filters: {
    letters: {},
    search: '',
    columns: {}
  },
  pagination: {
    sortBy: null,
    descending: false,
    page: 1,
    rowsPerPage: 25,
    rowsNumber: 25
  }
}

export const defaultState = {
  records: [],
  quickEditId: null,
  idList: [],
  defaultSort: null,
  defaultFilter: null,
  apiEndpoint: '/',
  namespace: '',
  clientRoute: '/',
  columns: [],
  settings: extend(true, {}, defaultSettings),
  loading: false,
  params: {},
  excelExport: {},
  titleColumn: undefined,
  subtitleColumn: undefined,
  fakeColumns: undefined,
  infoColumns: []
}

const createState = state => {
  let filterKeys = {}
  let visibleColumns = {}
  if (state.columns && Array.isArray(state.columns)) {
    if (state.columns[0].name !== 'action_edit') {
      state.columns.unshift(editActionColumn)
    }
    const columnLength = state.columns.length
    if (state.columns[columnLength - 1].name !== 'action_delete') {
      state.columns.push(deleteActionColumn)
    }
    // -- assign filter keys
    filterKeys = state.columns.reduce((obj, column) => {
      obj[column.field] = shvl.get(state, `settings.filters.columns[${column.field}]`, null)
      return obj
    }, {})
    // -- assign visible columns
    visibleColumns = state.columns.filter(col => col.visible || col.required).map(c => c.field)
  }
  return extend(true, {}, defaultState, state, {
    settings: {
      filters: {
        columns: filterKeys
      },
      visibleColumns: visibleColumns
    }
  })
}

export default createState
